import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("meta", {
  "http-equiv": "Content-Security-Policy",
  content: "default-src *; script-src * 'unsafe-inline' 'unsafe-eval';"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WelCome = _resolveComponent("WelCome")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_WelCome, { msg: "Welcome to Your Vue.js + TypeScript App" }),
    _hoisted_2
  ]))
}